<template>
<a-tooltip>
    <template slot="title">
        Decline
    </template>
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path class="first" d="M0.5 13C0.5 6.09653 6.09676 0.5 13 0.5C19.9037 0.5 25.4999 6.09651 25.4999 13C25.4999 19.9034 19.9039 25.4999 13 25.4999C6.09676 25.4999 0.5 19.9034 0.5 13Z" fill="white" stroke="#FA5C7C"/>
<path class="second" d="M8.07575 9.33843L11.7374 13L8.07575 16.6615C7.75467 16.9826 7.74725 17.5339 8.1066 17.8933C8.46598 18.2527 9.01733 18.2453 9.33842 17.9242L13 14.2626L16.6617 17.9242C16.9827 18.2452 17.534 18.2526 17.8934 17.8933C18.2527 17.5339 18.2453 16.9826 17.9243 16.6616L14.2627 13L17.9243 9.33837C18.2453 9.01732 18.2527 8.46604 17.8934 8.10668C17.534 7.74732 16.9827 7.75473 16.6617 8.07577L13 11.7373L9.33842 8.07574C9.01733 7.75465 8.46598 7.74725 8.1066 8.10667C7.74724 8.46607 7.75468 9.01736 8.07575 9.33843Z" fill="#FA5C7C"/>
</svg>
</a-tooltip>

</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
svg {
    cursor: pointer;
    path {
        transition: all 0.2s ease;
    }
    &:hover {
        path.first {
            fill: #FA5C7C; 
        }
        path.second {
            fill: #ffffff;
        }
    }
}
</style>